import * as DOMPurify from 'dompurify';
import { EFonts } from 'libs/styles/styling';
import { convertNewLineIntoBr, displayMarkdownInText } from 'libs/utils/logic/ui/markdownLogic';
import { normalizeLink } from 'libs/utils/text/normalizeLink';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.getAttribute('data-action')) {
        return;
    }

    if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('href', normalizeLink(node.getAttribute('href')));
        node.setAttribute('rel', 'noopener');
    }
});

interface Props {
    text: string;
    className?: string;
    showReadMore?: boolean;
    isWide?: boolean;
    onClick?: () => void;
}

export const MarkdownContent = (props: Props): JSX.Element => {
    const text = props.showReadMore
        ? props.text + `...&nbsp;<a href="#" data-action="#read-more">${Localization.SHOW_MORE}</a>`
        : props.text;

    return (
        <S_MarkdownContent
            onClickCapture={props.onClick}
            className={props.className}
            $isWide={props.isWide}
            onClick={(e) => {
                if (e.target instanceof HTMLAnchorElement) {
                    const targetLink = e.target as HTMLAnchorElement;
                    if (targetLink?.getAttribute('data-action') === '#read-more') {
                        e.preventDefault();
                    }
                }
            }}
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(displayMarkdownInText(convertNewLineIntoBr(text)))
            }}
        />
    );
};

const S_MarkdownContent = styled.div<{ $isWide: boolean }>`
    color: #4a4a4a;
    font-family: ${EFonts.InterMedium};
    font-size: 15px;
    line-height: 27px;
    ul,
    ol {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0 15px;
        li {
            margin: 2px 0;
        }
    }
    a {
        text-decoration: underline;
        cursor: pointer;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    h7 {
        font-weight: normal;
        font-family: ${EFonts.InterBold};
    }
    ul {
        padding-top: 5px;
    }
    li {
        font-family: ${EFonts.InterMedium};
    }
    strong {
        font-weight: normal;
        font-family: ${EFonts.InterBold};
    }
    a[data-action='#read-more'] {
        cursor: pointer;
        color: #4a4a4a;
        text-decoration: none;
        font-weight: normal;
        font-family: ${EFonts.InterBold};
    }
`;
